module.exports = __webpack_public_path__ + "img/mys.e6739f40.svg";